import { useApolloClient, useMutation } from '@apollo/client/react';
import { Alert, Button, Flex, Form, Modal } from 'antd';

import SectionMessage from 'components/SectionMessage/SectionMessage';
import { UPDATE_PRECO_PAYMENT_PLAN } from 'mutations/prechargeoff';
import { SIZE, STATUS } from 'utilities/constants';

import PrecoEFTAForm from './PrecoEFTAForm';

const PrecoUpdatePaymentPlanModal = ({
  offerId,
  transactions,
  fundingAccount,
  hide,
  ...modalProps
}) => {
  const client = useApolloClient();

  const [eftaForm] = Form.useForm();

  const [updatePaymentPlan, { loading, error, data: updateSuccess, reset }] =
    useMutation(UPDATE_PRECO_PAYMENT_PLAN, {
      onError: () => {},
      onCompleted: () =>
        setTimeout(() => {
          client.refetchQueries({
            include: ['GetCurrentPrecoOffer', 'AccountHistory'],
          });
          reset();
          eftaForm.resetFields();
          hide();
        }, 2500),
    });

  const handleCancel = () => {
    eftaForm.resetFields();
    reset();
    hide();
  };

  const onFinish = (authorizationText) => {
    updatePaymentPlan({
      variables: { offerId, transactions, authorizationText },
    });
  };

  return (
    <Modal
      {...modalProps}
      title="Update Payment Plan"
      width={500}
      footer={null}
      onCancel={handleCancel}
      destroyOnHidden={true}
    >
      <div style={{ position: 'relative', overflow: 'hidden' }}>
        <PrecoEFTAForm
          form={eftaForm}
          onFinish={onFinish}
          fundingAccountLast4={fundingAccount?.numberLast4}
          schedule={transactions}
        >
          <Flex justify="flex-end" gap="var(--spacing-sm)">
            <Button onClick={handleCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Confirm and Update
            </Button>
          </Flex>
        </PrecoEFTAForm>
        {error && (
          <Alert
            banner
            type="error"
            title="Failed to update payment plan. Please try again."
            style={{ marginTop: 'var(--spacing-sm)' }}
          />
        )}
        <SectionMessage
          cover={true}
          status={STATUS.SUCCESS}
          size={SIZE.SM}
          text="Payment plan successfully updated"
          visible={!!updateSuccess}
        />
      </div>
    </Modal>
  );
};

export default PrecoUpdatePaymentPlanModal;
